import styled from '@benzinga/themetron';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { IRowNode, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import React from 'react';
import { NO_VALUE } from '../../Ticker';
import { CustomCellRendererProps } from 'ag-grid-react';
import { formatPrice, isNil, isNilOrEmpty, isNotNil } from '@benzinga/utils';
import { surprisePercent } from '../../../utils/formatters';

const ChangePercentRenderer: React.FC<CustomCellRendererProps> = props => {
  const val = props.value;
  const valFormat = props.valueFormatted;
  if (isNil(val) || val === '') {
    return <Neutral>{NO_VALUE}</Neutral>;
  } else if (val === 0) {
    return <Neutral>{valFormat}</Neutral>;
  } else if (val > 0) {
    return <Positive>{valFormat}</Positive>;
  } else {
    return <Negative>{valFormat}</Negative>;
  }
};

const Neutral = styled.div`
  padding: 0 6px;
`;

const Positive = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.positive} !important;
  fill: ${({ theme }) => theme.colors.statistic.positive} !important;
`;

const Negative = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.negative} !important;
  fill: ${({ theme }) => theme.colors.statistic.negative} !important;
`;

export const CalculatedChangePercentColDef = (
  colDef: AdvancedColDef,
  colDefIdBefore: string,
  colDefIdAfter: string,
): AdvancedColDef => ({
  cellRenderer: ChangePercentRenderer,
  cellStyle: { textAlign: 'right' },

  comparator: (_valueA: number, _valueB: number, nodeA: IRowNode, nodeB: IRowNode) =>
    nodeA.data[nodeA.id ?? ''] - nodeB.data[nodeB.id ?? ''],

  filter: 'agNumberColumnFilter',
  valueFormatter: ({ value }: ValueFormatterParams) =>
    isNotNil(value) && value !== ''
      ? `${formatPrice(value, {
          fixedPlace: 2,
        })}%`
      : NO_VALUE,
  valueGetter: ({ data }: ValueGetterParams) => {
    const epsEst = data[colDefIdBefore];
    const eps = data[colDefIdAfter];

    if (!isNilOrEmpty(eps) && !isNilOrEmpty(epsEst)) {
      return surprisePercent(epsEst, eps);
    }

    return 0;
  },
  ...colDef,
  ...absColDef(colDef),
});
